module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="nav-item nav-link" href="#'+
((__t=( url ))==null?'':_.escape(__t))+
'" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" oncontextmenu="return false">'+
((__t=( name ))==null?'':_.escape(__t))+
'</a>';
}
return __p;
};
